<template>
	<div id='contraAdd'>
		<h2>Agregar Contrato o Pre-Contrato</h2>
		<br>
		<a @click="$router.go(-1)">regresar</a>
		<br><br>

		<button type='button' v-on:click='aBuscarPre_o_Con("PRE-CONTRATO")' class="button is-primary is-rounded" >Buscar en Pre-Contratos</button>
		<button type='button' v-on:click='aBuscarPre_o_Con("RENTADO")' class="button is-primary is-rounded">Copiar un contrato</button>
		<br><br>

		<form v-on:submit.prevent= 'guardarContrato' id='visible' >
			<table align="center">
					<tr>
						<td align="right">Propiedad numero</td>
						<td align="left"><input disabled v-model="contratos.propiedadId" class="input is-rounded">
			      		<button type='button' class="button is-primary is-rounded" v-on:click='aBuscar'>Buscar</button>
						<router-link id='agre' :to="{name: 'agre-propi'}">Agregar</router-link>

			      		</td>
					</tr>
					<tr>
						<td align="right">Inquilino numero</td>
						<td align="left"><input disabled v-model="contratos.inquilinoId" class="input is-rounded">
			      		<button type='button' class="button is-primary is-rounded" v-on:click='aBuscarI'>Buscar</button>
			      		<router-link id="busca":to="{name: 'agre-inqui'}">Agregar</router-link>
			      		</td>
					</tr>
					<tr>
						<td align="right">Inquilino</td>
						<td align="left"><input type="text" disabled name="inquilino" v-model="contratos.inquilino" class="input is-rounded"></td>
					</tr>
					<tr>
						<td align="right">Direccion Inquilino</td>
						<td align="left"><input type="text" disabled name="inquilinoDir" v-model="contratos.dirI" class="input is-rounded"></td>
					</tr>
					<tr>
						<td align="right">Propiedad</td>
						<td align="left"><input type="text" disabled name="propiedad" v-model="contratos.propiedad" class="input is-rounded"></td>
					</tr>
					<tr>
						<td align="right">Familia</td>
						<td align="left"><input type="text" disabled name="familia" v-model="contratos.familia" class="input is-rounded"></td>
					</tr>				
					<tr>
						<td align="right">Sub familia</td>
						<td align="left"><input type="text" disabled name="subfamilia" v-model="contratos.subfamilia" class="input is-rounded"></td>
					</tr>
                    <tr>
                        <td align="right">Clave catastral</td>
                        <td align="left"><input type="text" disabled name="claveCat" v-model="contratos.claveCat" class="input is-rounded"></td>
                    </tr>


					<tr>
						<td align="right">Area</td>
						<td align="left"><input type="text" disabled name="area" v-model="contratos.metrosCuadrados" class="input is-rounded"></td>
					</tr>				
					<tr>
						<td align="right">Medidas y colindancias</td>
						<td align="left"><input type="text" disabled name="colin" v-model="contratos.medidasYcol" class="input is-rounded"></td>
					</tr>

					<tr>
						<td align="right">Contrato o Pre-Contrato </td>
						<td align="left"><strong>
							<select name="cop" required v-model="conpre" v-on:change='visibleInicio()' class="input is-rounded">
	  							<option value="P" selected >Pre-Contrato</option>
								<option value="C" >Contrato</option>
							</select>
						</strong>
						</td>
					</tr>

					<tr>
						<td align="right">Nombre Comercial </td>
						<td align="left"><input type="text" required minlength="4"  name="nombreComercial" v-model="contratos.nombreComercial" class="input is-rounded"></td>
					</tr>
					<tr>
						<td align="right">Giro</td> 
						<td align="left"><input type="text" required minlength="4" name="giro" v-model="contratos.giro" class="input is-rounded"></td>
					</tr>
					<tr>
						<td align="right">Renta Mensual</td>
						<td align="left"><input type="number" required min="100" name="importeMes" v-model="contratos.importeMes" class="input is-rounded" v-on:keyup="diaria(contratos.importeMes)">
						<br>
						<b>Renta diaria: $ {{formateaNumero(rentaDiaria)}}</b>
						</td>
					</tr>
					<tr>
						<td align="right">Inicia el contrato</td>
						<td align="left">
							<input type="date" required name="fechaInicio" v-model="contratos.fechaInicio" class="input is-rounded">
							<br>{{formateaFecha(contratos.fechaInicio)}}
						</td>
					</tr>
					<tr>
						<td align="right">Termina el contrato</td>
						<td align="left">
							<input type="date" required name="fechaFinal" v-model="contratos.fechaFinal" class="input is-rounded">
							<br>{{formateaFecha(contratos.fechaFinal )}}
						</td>
					</tr>
					<tr>
						<td align="right">Saldo inicial</td>
						<td align="left"><input type="number" required min="0"  name="saldoI" v-model="contratos.saldoInicial" class="input is-rounded"> <p>El importe del depósito en Garantia </p><p>captúrelo después en Movimientos con</p><p> el TIPO "Deposito en Garantía", </p><p>No agregue aquí el depósito en garantía </p><p> como parte del saldo inicial</p></td>
					</tr>
					<tr id = "fechaSaldo" >
						<td align="right" style="color:red">
							<p><b>Fecha del saldo inicial.</b></p>
							<p>Al día siguiete</p>
							<p>iniciarán los cargos </p>
							<p>mensuales de renta</p>

						</td>
						<td align="left" style="color:red" >
							<p>
								<input type="date" required id="fs" v-model="contratos.fechaSaldoInicial"  class="input is-rounded">
								<br>El primer cargo será a razón de $ {{formateaNumero(rentaDiaria)}} diarios
								<br>AL DIA SIGUIENTE del  {{formateaFecha(contratos.fechaSaldoInicial)}}
							</p>
							<br>
							<p>ESTA FECHA NO SE PUEDE</p>
							<p>CAMBIAR DESPUES</p>
							<p><sup>(Inicio del control del sistema al DIA SIGUIENTE)</sup></p>

						</td>
					</tr>

					<tr>
						<td align="right">Identificación del inquilino</td>
						<td align="left"><input type="text" name="idinq" required v-model="contratos.idInquilino" class="input is-rounded"></td>
					</tr>
					<tr>
						<td align="right">Comprobante domicilio inquilino</td>
						<td align="left"><input type="text" name="comdom" required v-model="contratos.comDomInquilino" class="input is-rounded"></td>
					</tr>

					<tr>
						<td align="right">Nombre completo aval</td>
						<td align="left"><input type="text" name="naval" v-model="contratos.nombreAval" class="input is-rounded"></td>
					</tr>
					<tr>
						<td align="right">Dirección completa aval</td>
						<td align="left"><input type="text" name="daval" v-model="contratos.direccionAval" class="input is-rounded" maxlength="250"></td>
					</tr>
					<tr>
						<td align="right">Celular aval</td>
						<td align="left"><input type="phone" name="caval" v-model="contratos.celularAval" class="input is-rounded"></td>
					</tr>
					<tr>
						<td align="right">Email aval</td>
						<td align="left"><input type="email" name="eaval" v-model="contratos.emailAval" class="input is-rounded"></td>
					</tr>
					<tr>
						<td align="right">Facebook aval</td>
						<td align="left"><input type="text" name="faval" v-model="contratos.facebookAval" class="input is-rounded"></td>
					</tr>
                    <tr>
                        <td align="right">Depositar a </td>
                        <td align="left"><input type="text" required name="depA" v-model="contratos.depositarA" class="input is-rounded"></td>
                    </tr>                    
					<tr>
						<td></td>
						<td><input type="submit" class="button is-primary is-rounded" name="agre"></td>
					</tr>
	      	</table>
		</form>

		<p>
  			<hijo1 v-if='buscar' v-on:eventoP= 'recibeP(...arguments)'>Cargando propiedades...</hijo1>
  		</p>

		<p>
  			<hijo2 v-if='buscar1' v-on:eventoI= 'recibeI(...arguments)'>Cargando inquilinos...</hijo2>
  		</p>

		<p>
  			<hijo3 v-if='buscarProf' v-bind:esProformaOcontrato='poc' v-on:eventoProf= 'recibePro_o_Con(...arguments)'>Cargando proformas...</hijo3>

  		</p>

	</div>
</template>

<script>
	import axios from 'axios';
	import prop1 from './Propiedades-buscar.vue'
	import inq1  from './Inquilinos-buscar.vue'
	import profor1  from './Pre-o-Contratos-buscar.vue'

	export default{
			name:'agrega-contrato',
			
			components: {hijo1: prop1, hijo2: inq1, hijo3: profor1},
  			props: ['vector', 'elusuario'],  

  			mounted(){
				this.contratos.fechaSaldoInicial = this.hoy();
				this.visibleInicio();
  			},

			data(){
				return {
					contratos:{
						id:'',
						inquilinoId:'',
						propiedadId:'',
						inquilino:'',
						propiedad:'',
						nombreComercial:'',
						giro:'',
						familia:'',
						subfamilia:'',
						idInquilino:'',
						comDomInquilino:'',
						dueno:'',
						dirI:'',
						celI:'',
						email:'',
						wappI:'',
						importeMes: 0,
						fechaInicio:'',
						fechaFinal:'',
						fechaModificacion:'',
						quienModifico:'GGUV',
						saldoInicial: 0,
						fechaSaldoInicial:'',
						email:'',
						celular:'',
						telefono:'',
						facebook:'',
						nombreAval:'',
						direccionAval:'',
						emailAval:'',
						celularAval:'',
						telefonoAval:'',
						facebookAval:'',
						whatsapp:'',
						idInquilino:'',
						comDomInquilino:'',
						metrosCuadrados:'',
						medidasYcol:'',
						status:'',
                        depositarA:'',
                        claveCat:''
					},
					idPro:'',
					buscar: false,
					buscar1:false,
					buscarProf:false,
					poc:'',
					conpre:'P',
					rentaDiaria: '',
					primerCargo: 0,
					primeraFecha:''

				};

			},
			methods:{
				aBuscar(){
					this.buscar = true;
					document.getElementById('visible').style.height = "0";	
					document.getElementById('visible').style.visibility = "hidden";
				},
				aBuscarI(){
					this.buscar1 = true;
					document.getElementById('visible').style.height = "0";	
					document.getElementById('visible').style.visibility = "hidden";
				},
				aBuscarPre_o_Con(profOcontra){
					this.poc = profOcontra;
					this.buscarProf = true;
					document.getElementById('visible').style.height = "0";	
					document.getElementById('visible').style.visibility = "hidden";
				},
			  	hoy(){
			  		// regresa la fecha actual en formato YYYY-mm-dd
			  		var fech = new Date();
           			var dia = fech.getDate();
           			if(dia < 10) dia = '0' + dia;
           			var mes = fech.getMonth() + 1;
           			if(mes < 10) mes = '0' + mes;
           			var año = fech.getFullYear();
           			return año + '-' + mes + '-' + dia;
			  	},
				recibeP: function(id, prop2, fam2, subfam2, dueno, area, medidas, claveCat){

					this.contratos.propiedadId=id;
					this.contratos.propiedad=prop2;
					this.contratos.familia=fam2;
					this.contratos.subfamilia=subfam2;
					this.contratos.dueno=dueno;
					this.contratos.metrosCuadrados = area;
					this.contratos.medidasYcol = medidas;
                    this.contratos.claveCat = claveCat;

					this.buscar=false;
					document.getElementById('visible').style.visibility = "visible";	

				},
				recibeI: function(id,prop2,email,celular,telefono, whatsapp, facebook, dirI, celI, fbI, wappI){

					this.contratos.inquilinoId = id;
					this.contratos.inquilino = prop2;
					this.contratos.email = email;
					this.contratos.celular = celular;
					this.contratos.telefono = telefono;
					this.contratos.facebook = facebook;
					this.contratos.dirI = dirI;
					this.contratos.celI = celI;
					this.contratos.fbI = fbI;
					this.contratos.wappI = wappI;

					this.buscar1=false;
					document.getElementById('visible').style.visibility = "visible";
				},

				recibePro_o_Con: function(inId, prId, inq, pr, gir, fam, subfam, dueno, elmail, renta, cel, fb, dirI, wappI, iniciaC, finC, idI, comprob, nomAval, dirAval, celAval, mailAval, fbAval, nombreComercial, medidas, area, claveCat){

					this.contratos.inquilinoId = inId;
					this.contratos.inquilino = inq;
					this.contratos.email = elmail;
					this.contratos.giro = gir;

					this.contratos.celular = cel;
					this.contratos.facebook = fb;
					this.contratos.dirI = dirI;
					this.contratos.nombreComercial = nombreComercial;

					this.contratos.wappI = wappI;
					this.contratos.fechaInicio = iniciaC;
					this.contratos.fechaFinal = finC;
					this.contratos.idInquilino = idI;
					this.contratos.comDomInquilino = comprob;
					this.contratos.nombreAval = nomAval;
					this.contratos.direccionAval = dirAval;
					this.contratos.celularAval = celAval;
					this.contratos.emailAval = mailAval;
					this.contratos.facebookAval = fbAval;

					this.contratos.propiedadId = prId;
					this.contratos.propiedad = pr;
					this.contratos.familia = fam;
					this.contratos.subfamilia = subfam;
					this.contratos.dueno = dueno;
					this.contratos.importeMes = renta;

					this.contratos.metrosCuadrados = area;
					this.contratos.medidasYcol = medidas;
                    this.contratos.claveCat = claveCat;

					// actualiza en pantalla la renta diaria
					this.diaria(this.contratos.importeMes);

					this.buscarProf = false;
					document.getElementById('visible').style.visibility = "visible";		

				},

				diaria(rentaMes){
					this.rentaDiaria = rentaMes / 30;					
				},

				visibleInicio(){
					// hace invisible la fecha del saldo si es que es un pre-contrato
					var fi = document.getElementById('fechaSaldo');
					if (this.conpre == 'P') {
						fi.style.visibility = "hidden";
					} else fi.style.visibility = "visible";
				},

				formateaFecha: function (fecha) {					
					var d = new Date(fecha); 
					if (Date.parse(d)){
						// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
						d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
						d.setHours(0);
						var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
						d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
						return d

					}else{
						return "sin fecha";
					}
				},

				guardarContrato(){

					// valida entradas
					var contratos1 = this.contratos;

					if(contratos1.inquilinoId == '' || contratos1.propiedadId == ''){
						alert('Falta Propiedad Num. o Inquilino Num.');
						return;
					};

					if(this.fechams(contratos1.fechaFinal) < this.fechams(contratos1.fechaInicio)){
						alert('La fecha final del contrato debe ser mayor a la fecha de inicio');
						return;
					};

					if(contratos1.direccionAval.includes('#')){
						alert("caracter no permitido en direccion aval: #");
						return;
					};

					if (confirm(
						"\n\n           Es correcta la informacion ?\n\n" +
						"Inquilino: " + contratos1.inquilino + 
						"\nPropiedad: " + contratos1.propiedad + 
						"\nNombre Comercial: " + contratos1.nombreComercial + 
						"\nGiro: " + contratos1.giro + 
						"\nFamilia: " + contratos1.familia + 
						"\nSub familia: " + contratos1.subfamilia + 
						"\nFecha inicio: " + this.formateaFecha(contratos1.fechaInicio) + 
						"\nFecha final: " + this.formateaFecha(contratos1.fechaFinal) + 
						"\nRenta mensual: $ " + this.formateaNumero(contratos1.importeMes) + 
						"\nSaldo inicial: " + contratos1.saldoInicial + 
						"\nFecha saldo inicial: " + contratos1.fechaSaldoInicial + 
						"\n\nComprobante dom: " + contratos1.comDomInquilino + 
						"\nDireccion: " + contratos1.dirI + 
						"\nCelular: " + contratos1.celular + 
						"\nEmail: " + contratos1.email + 
						"\nFacebook: " + contratos1.fbI + 
						"\n\nAval: " + contratos1.nombreAval + 
						"\nAval celular: " + contratos1.celularAval + 
						"\nAval direccion:" + contratos1.direccionAval + 
						"\nAval email: " + contratos1.emailAval + 
						"\nAval facebook: " + contratos1.facebookAval +
                        "\nDepositar A: " + contratos1.depositarA +
                        "\nClave catastral: " + contratos1.claveCat +

						"\n\n           Es correcta la informacion ?")) {

					} else {
    					return;
					}

					// checa is es pre-contrato o ya es contrato
					var esProforma = this.conpre;

					if (esProforma.toUpperCase() === "P") contratos1.status = "PRE-CONTRATO";
					if (esProforma.toUpperCase() === "C") contratos1.status = "RENTADO";
					if (!esProforma.toUpperCase() === "C" && !esProforma.toUpperCase() === "P") return;

					//this.ultimoContrato = 'uno';
					var cadena = 'https://www.directodo.com/Rentus/accesosdb/agregaContrato.php?inquilinoId='+contratos1.inquilinoId+
						'&propiedadId='+contratos1.propiedadId+
						'&inquilino='+contratos1.inquilino+
						'&propiedad='+contratos1.propiedad+
						'&nombreComercial='+contratos1.nombreComercial+
						'&giro='+contratos1.giro+
						'&fam='+contratos1.familia+
						'&subfam='+contratos1.subfamilia+
						'&importeMes='+contratos1.importeMes+
						'&fechaModificacion='+this.fechaActual()+
						'&fechaFin='+contratos1.fechaFinal+
						'&fechaInicio='+contratos1.fechaInicio+
						'&quienModifico='+ this.elusuario+
						'&saldoInicial='+contratos1.saldoInicial+
						'&fechaSaldo='+contratos1.fechaSaldoInicial+
						'&nombreAval='+contratos1.nombreAval+
						'&direccionAval='+contratos1.direccionAval+
						'&celularAval='+contratos1.celularAval+
						'&emailAval='+contratos1.emailAval+
						'&idI='+contratos1.idInquilino+
						'&comDomI='+contratos1.comDomInquilino+
						'&dirI='+contratos1.dirI+
						'&celI='+contratos1.celI+
						'&emailI='+contratos1.email+
						'&fbI='+contratos1.fbI+
						'&fbAval='+contratos1.facebookAval+
						'&wapp='+contratos1.whatsapp+
						'&status='+contratos1.status+
						'&dueno='+contratos1.dueno+
						'&area='+contratos1.metrosCuadrados+
                        '&depA='+contratos1.depositarA+
                        '&claveC='+contratos1.claveCat+
						'&medidas='+contratos1.medidasYcol; 

					// le quita los gatitos # porque al dar de alta en mysql en php corta la cadena de parametros si va un gato #
					var cadena2 = cadena.replace(/#/g,'');
					
					// da de alta el contrato en archivo de contratos
					axios.get(cadena2)
							.then((respue) => {
			  		        	if (respue.statusText == 'OK'){
			  		        		// si es proforma no da de alta los movimientos
			  		        		if(esProforma.toUpperCase() === "P") return;

									// agrega los cargos de renta mensual de cada contrato.
									axios.post('https://www.directodo.com/Rentus/accesosdb/agregaRentas.php?fa=' + this.hoy())
										.then((respue) => {
						  		        	if (respue.statusText == 'OK'){
						  		        		alert('Rentas agregadas');
						  		          	}
				  			 	  		})
				  		          		.catch((error) =>{
				  		          			alert('No se pudieron agregar las rentas en movimientos. Error: '+error);
				  		          		}
				  		          		);
			  		          	}
			  		          	
	  			 	  		})
	  		          		.catch((error) =>{
	  		          			alert('No se pudo dar de alta el contrato. Error: '+error);
	  		          		}
	  		          		);

							var router= this.$router;
							router.push('/con');// se va al menu con


				}, // termina guardaContrato

				fechaActual(){      
				    var currentDate = new Date() //hoy
				    var day = currentDate.getDate();
				    var month = currentDate.getMonth() + 1;
				    var year = currentDate.getFullYear();
				    var my_date = year+"-"+month+"-"+day;
				    return my_date;    
				},

				fechams(fecha){
					var laFecha = new Date(fecha);
					return laFecha.getTime();// obtiene los milisegundos de la fecha

				},

				formateaFecha: function (fecha) {
					var d = new Date(fecha); 
					if (Date.parse(d)){
						// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
						d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
						d.setHours(0);
						var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
						d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
						return d

					}else{
						return "sin fecha";
					}
				},

			    formateaNumero(valor1) {
			        return (Number(valor1)).toLocaleString('en-US', {maximumFractionDigits: 2, minimumFractionDigits:2, useGrouping:true});
			    }

			}

	}

</script>


// WEBPACK FOOTER //
// src/Contrato-agregar.vue